import { sectionNames } from "@dashboard/intl";
import { parse as parseQs } from "qs";
import { FC } from "react";
import { useIntl } from "react-intl";
import { Route, RouteComponentProps, Switch } from "react-router-dom";

import { WindowTitle } from "../components/WindowTitle";
import { newsletterListPath, NewsletterListUrlQueryParams } from "./urls";
import { NewsletterListView } from "./views/NewsletterListView";

const NewsletterList: FC<RouteComponentProps> = ({ location }) => {
  const qs = parseQs(location.search.substr(1)) as any;
  const params: NewsletterListUrlQueryParams = qs;

  return <NewsletterListView params={params} />;
};

const NewsletterSection: FC = () => {
  const intl = useIntl();

  return (
    <>
      <WindowTitle title={intl.formatMessage(sectionNames.newsletter)} />
      <Switch>
        <Route exact path={newsletterListPath} component={NewsletterList} />
      </Switch>
    </>
  );
};

export default NewsletterSection;
